import React from "react";
import { PRESENCE_STATUS_LABEL, VACATION_REQUEST_STATUS_LABELS } from "../../../configs/constants";

import {
  computeEventInfos,
  computeTitleOfHalfDay,
  computeTypeOfHalfDay,
  isProcessed,
  isUnjustified,
  isValidated
} from "../utils/utils";

const buildBadgeElement = (content, onClick) => {
  let classes = "rounded-full p-2 w-full h-8 my-1 text-center cursor-pointer ";
  if (content.isUnjustified && !content.processed) {
    classes += "bg-red-200 text-black border border-black ";
  } else if (content.type === PRESENCE_STATUS_LABEL.NON_WORK) {
    classes += "bg-purple-300 text-white ";
  } else if (content.type === VACATION_REQUEST_STATUS_LABELS.PENDING || (!content.validated && !content.processed)) {
    classes += "bg-gray-200 text-black border-black border ";
  } else if (!content.validated && content.processed && content.type === PRESENCE_STATUS_LABEL.ATTENDANCE) {
    classes += "bg-white text-green-400 border-green-400 border ";
  } else if (!content.validated && content.processed && content.type === PRESENCE_STATUS_LABEL.VACATION) {
    classes += "bg-white text-red-400 border-red-400 border ";
  } else if (!content.validated && content.processed && content.isUnjustified) {
    classes += "border-red-400 text-red-400 bg-white border-2 ";
  } else if (!content.validated && content.processed && content.type === PRESENCE_STATUS_LABEL.ABSENCE) {
    classes += "bg-white text-yellow-500 border-yellow-500 border ";
  } else if (content.validated && content.type === PRESENCE_STATUS_LABEL.ATTENDANCE) {
    classes += "bg-green-400 text-white ";
  } else if (content.isUnjustified) {
    classes += "bg-red-500 text-white border-black border-2 ";
  } else if (content.validated && content.type === PRESENCE_STATUS_LABEL.ABSENCE) {
    classes += "bg-red-500 text-white  ";
  } else if (content.type === PRESENCE_STATUS_LABEL.VACATION) {
    classes += "bg-yellow-500 text-white  ";
  } else classes += "bg-purple-300  text-white";

  return (
    <div style={{ width: "135px" }} className={classes} onClick={onClick}>
      {content.title}
    </div>
  );
};

const AttendanceBadge = ({ dayIndex, day = {}, period, setModalOpen, setModalAttendanceOpen, setModalType }) => {
  const attendances = day.attendances || {};
  const presenceData = {
    position: period,
    validated: isValidated(attendances[period]),
    type: computeTypeOfHalfDay(day, period),
    title: computeTitleOfHalfDay(day, period),
    processed: isProcessed(attendances[period]),
    isUnjustified: isUnjustified(day, period)
  };

  return buildBadgeElement(presenceData, () => {
    if (computeTypeOfHalfDay(day, period) === VACATION_REQUEST_STATUS_LABELS.PENDING) {
      const eventInfos = computeEventInfos(day, period);
      setModalType({ type: "pending", payload: eventInfos });
      setModalOpen(true);
    } else {
      setModalType({ type: "attendance", dayIndex: dayIndex });
      setModalAttendanceOpen(true);
    }
  });
};

export default AttendanceBadge;



// WEBPACK FOOTER //
// src/modules/presence/components/AttendanceBadge.js